module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.packages.all), function(package, index) {
    return (package.packingLevel == 2 || package.packingLevel == 3) ? _c('el-row', [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-card', {
      staticClass: "box-card package-card"
    }, [_c('div', {
      staticClass: "clearfix card-header",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticClass: "card-header-text"
    }, [_c('i', {
      staticClass: "el-icon-goods"
    }), _vm._v(" " + _vm._s(package.packingLevel == 2 ? 'Pallet' : 'Box') + " # " + _vm._s(index) + " - " + _vm._s(package.sscc) + " ")]), _vm._v(" "), _c('el-select', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (_vm.selectedPaperSize),
        callback: function($$v) {
          _vm.selectedPaperSize = $$v
        },
        expression: "selectedPaperSize"
      }
    }, _vm._l((_vm.paperSizes), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.name,
          "value": item.value
        }
      })
    }), 1), _vm._v(" "), _c('el-button', {
      staticClass: "small",
      staticStyle: {
        "margin": "3px 0px"
      },
      attrs: {
        "type": "text",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.viewPackageBarcode(package.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.package.viewShippingLabel')))]), _vm._v(" "), _c('el-button', {
      staticClass: "small",
      staticStyle: {
        "margin": "3px 0px"
      },
      attrs: {
        "type": "text",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.viewMixPalletPackageBarcode(package.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.package.viewProductMixLabel')))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "margin": "5px 5px",
        "float": "right",
        "padding": "4px 12px",
        "background": "#1bbc9b",
        "color": "#FFF",
        "border": "0"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.activateAddProductToPackageModal(package.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('static.orders.package.addProduct')))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "margin": "5px 5px",
        "float": "right",
        "padding": "4px 12px",
        "background": "#1bbc9b",
        "color": "#FFF",
        "border": "0"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.activateEditPacakge(package)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('static.orders.package.editPackage')))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "margin": "5px 5px",
        "float": "right",
        "padding": "4px 12px",
        "background": "#ff6c5f",
        "color": "#FFF",
        "border": "0"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDeletePackage(package.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('static.orders.package.deletePackage')))])], 1), _vm._v(" "), _c('div', [_c('el-row', {
      attrs: {
        "gutter": 35
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.sscc')) + ": " + _vm._s(package.sscc) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.unitType')) + ": " + _vm._s(package.packageUnitTypeNoCode) + " ")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.numberOfProducts')) + ": " + _vm._s(package.numberOfProducts) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.totalQuantity')) + ": " + _vm._s(package.totalQuantity) + " ")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.totalNetWeight')) + ": " + _vm._s(package.totalNetWeight) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.totalGrossWeight')) + ": " + _vm._s(package.totalGrossWeight) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.totalStackWeight')) + ": " + _vm._s(package.totalStackWeight) + " ")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Products: ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.getPackageOrderProductById(package.id),
        "cell-class-name": "package-cell"
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "gtin",
        "label": _vm.$t('static.orders.package.createdPackage.table.gtin'),
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "productName",
        "label": _vm.$t('static.orders.package.createdPackage.table.productName'),
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "quantityText",
        "label": _vm.$t('static.orders.package.createdPackage.table.quantity')
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "weights",
        "label": _vm.$t('static.orders.package.createdPackage.table.weight')
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "bestBefore",
        "label": _vm.$t('static.orders.package.createdPackage.table.bestBefore')
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "maxTopLoad",
        "label": _vm.$t('static.orders.package.createdPackage.table.maxTopLoad')
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "batchLotNumber",
        "label": _vm.$t('static.orders.package.createdPackage.table.lotBatchNumber')
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "temperatureText",
        "label": _vm.$t('static.orders.package.createdPackage.table.temperatureRequirement')
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": " ",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            staticClass: "small",
            staticStyle: {
              "margin": "3px 0px"
            },
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                _vm.viewProductBarcode(_vm.getPackageOrderProductById(package.id)[scope.$index])
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-file-pdf-o"
          })]), _vm._v(" "), _c('el-button', {
            staticClass: "small",
            staticStyle: {
              "margin": "3px 0px"
            },
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                _vm.editpackageOrderProduct(_vm.getPackageOrderProductById(package.id)[scope.$index])
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-edit"
          })]), _vm._v(" "), _c('el-button', {
            staticClass: "small danger",
            staticStyle: {
              "margin": "3px 0px"
            },
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                _vm.confirmToRemovePackage(_vm.getPackageOrderProductById(package.id)[scope.$index])
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-times"
          })])]
        }
      }], null, true)
    })], 1)], 1)], 1)], 1)])], 1)], 1) : _vm._e()
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83af8ce2","hasScoped":false}!./src/app/components/managePackage/managePackage.html
// module id = 3083
// module chunks = 1